import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { User } from 'src/app/component/auth/model/user.model';
import { SchoolDistrict } from 'src/app/model/schoolDistrict.model';
import { Region } from 'src/app/model/region.model';
import { Role } from 'src/app/model/roles';
import { UserModel, USERROLE } from '../model/user';
import { PopOverComponent } from 'src/app/component/common-components/pop-over/pop-over.component';
import { MsgModel } from 'src/app/component/common-components/msg/model/msg.model';
import { MatPaginator } from '@angular/material/paginator';
import { timer } from 'rxjs';
import { AccountService } from '../service/account.service';
import { AccountSearchRequestDataView } from '../model/search-account-request-data-view';
import { ViewAccountComponent } from '../search-accounts/view-account/view-account.component';
import { EditAccountComponent } from '../search-accounts/edit-account/edit-account.component';
import { TooltipPosition } from '@angular/material/tooltip';
import { ConfirmChangesComponent } from 'src/app/component/common-components/confirm-changes/confirm-changes.component';
import { LoginTokenService } from 'src/app/service/login-token.service';
import { Router } from '@angular/router';

const sortingDataAccessor = (item: User, property: string) => {
    switch (property) {
        case 'FIRSTNAME':
            if (item.PERSON?.FIRST_NAME) return item.PERSON?.FIRST_NAME?.toString().toLocaleLowerCase();
            else return '';
        case 'LASTNAME':
            if (item.PERSON?.LAST_NAME) return item.PERSON?.LAST_NAME?.toString().toLocaleLowerCase();
            else return '';
        case 'USERNAME':
            if (item.USER_ID) return item.USER_ID;
            else return '';
        case 'EMAIL':
            if (item?.EMAIL_ADDRESS) return item?.EMAIL_ADDRESS;
            else return '';
        case 'REGION':
            if (item.REGION?.NAME) return item.REGION?.NAME?.toString().toLocaleLowerCase();
            else return '';
        case 'ORGANIZATION':
            if (item.REGION?.ORGANIZATIONS_ID) return item.REGION?.ORGANIZATIONS_ID?.toString().toLocaleLowerCase();
            return '';
        case 'PHONENUMBER':
            if (item.TELEPHONE_NUMBERS == null || item.TELEPHONE_NUMBERS === undefined || item.TELEPHONE_NUMBERS.length <= 0) return '';
            else return item.TELEPHONE_NUMBERS[0].PHONE_NUMBER.toString().toLocaleLowerCase();
        case 'ROLES':
            if (item?.USER_ROLES && item.USER_ROLES[0].ROLE?.NAME) {
                return item?.USER_ROLES[0]?.ROLE?.NAME?.toString().toLocaleLowerCase();
            } else {
                return '';
            }
        case 'SCHOOLDISTRICT':
            if (item?.WORKS_FOR?.NAME) {
                return item?.WORKS_FOR?.NAME?.toString().toLocaleLowerCase();
            } else {
                return '';
            }
        case 'ACCOUNTSTATUS':
            if (item?.LOGIN_DETAIL_STATUS && item?.LOGIN_DETAIL_STATUS[0].LOGIN_DETAIL_STATUS_TYPES?.NAME)
                return item?.LOGIN_DETAIL_STATUS && item?.LOGIN_DETAIL_STATUS[0].LOGIN_DETAIL_STATUS_TYPES?.NAME.toString().toLocaleLowerCase();
            else return '';
        default:
            if (item?.ID) return item.ID;
            else return '';
    }
};

@Component({
    selector: 'app-global-admin',
    templateUrl: './global-admin.component.html',
    styleUrls: ['./global-admin.component.scss']
})
export class GlobalAdminComponent implements OnInit, AfterViewInit {
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) searchPaginator: MatPaginator;

    positionOptions: TooltipPosition[] = ['below', 'above', 'left', 'right'];
    position = new UntypedFormControl(this.positionOptions[0]);

    passwordResetStatus: boolean = false;
    currentSession: boolean = false;
    accountCreation: boolean = false;
    isLoadingCount: boolean = false;
    resetField: boolean = false;
    isLoadingResults: boolean = false;
    disableButton: boolean = true;

    lstSelectedRegion: Region[] = [];
    lstSelecteddistrict: SchoolDistrict[] = [];
    lstSelectedRole: Role[] = [];
    lstUser: User[] = [];

    dataSource = new MatTableDataSource<User>();
    searchTextCtrl = new UntypedFormControl('');

    msg = new MsgModel();

    totalSessionCount: number;

    displayedColumns: string[] = [
        'ACTIONGLOBAL',
        'FIRSTNAME',
        'LASTNAME',
        'USERNAME',
        'EMAIL',
        'REGION',
        'ORGANIZATION',
        'PHONENUMBER',
        'ROLES',
        'SCHOOLDISTRICT',
        'ACCOUNTSTATUS'
    ];

    constructor(public accountService: AccountService, private dialog: MatDialog, private loginTokenService: LoginTokenService, private router: Router) {}

    ngOnInit(): void {
        this.searchTextCtrl.valueChanges.subscribe((x) => {
            this.disableButton = !this.validateSearchEnable();
            if (!this.disableButton) this.msg = new MsgModel();
        });
        this.getSessionCount();
    }
    ngAfterViewInit() {
        this.dataSource.paginator = this.searchPaginator;
    }
    applyFilter(event: any) {
        if (!this.disableButton) this.search(false);
    }

    search(activeSession: boolean) {
        this.msg = new MsgModel();
        this.isLoadingResults = true;
        this.dataSource = new MatTableDataSource<User>();
        this.disableButton = true;
        if (this.validateSearchEnable() && this.isLoadingResults && !activeSession) {
            const accountRequest = {} as AccountSearchRequestDataView;
            accountRequest.searchString = this.searchTextCtrl?.value;
            accountRequest.regions = this.lstSelectedRegion;
            accountRequest.schoolDistricts = this.lstSelecteddistrict;
            accountRequest.roles = this.lstSelectedRole;
            //Need to understand the existing API what is meant by Super
            accountRequest.type = 'SUPER';

            this.accountService.getAccountSearchV2(accountRequest).subscribe((x: any) => {
                if (x['users'] === undefined) {
                    if (x['msg'] !== undefined) {
                        this.msg = x['msg'];
                    }
                } else {
                    this.lstUser = JSON.parse(x['users']);
                    this.lstUser.sort((a, b) =>
                        (a.PERSON?.FIRST_NAME ? a.PERSON?.FIRST_NAME.toString() : '') > (b.PERSON?.FIRST_NAME ? b.PERSON?.FIRST_NAME : '') ? 1 : -1
                    );

                    this.dataSource.data = this.lstUser;
                    this.announceSortChange({ active: 'FIRSTNAME', direction: 'desc' });
                }
                this.isLoadingResults = false;
                this.disableButton = false;
            });
        } else if (activeSession) {
            const accountRequest = {} as AccountSearchRequestDataView;
            accountRequest.activeSessionsOnly = true;
            //Need to understand the existing API what is meant by Super
            accountRequest.type = 'SUPER';

            this.accountService.getAccountSearchV2(accountRequest).subscribe((x: any) => {
                if (x['users'] === undefined) {
                    if (x['msg'] !== undefined) {
                        this.msg = x['msg'];
                    }
                } else {
                    this.lstUser = JSON.parse(x['users']);
                    this.lstUser.sort((a, b) =>
                        (a.PERSON?.FIRST_NAME ? a.PERSON?.FIRST_NAME.toString() : '') > (b.PERSON?.FIRST_NAME ? b.PERSON?.FIRST_NAME : '') ? 1 : -1
                    );

                    this.dataSource.data = this.lstUser;
                    this.announceSortChange({ active: 'FIRSTNAME', direction: 'desc' });
                }
                this.isLoadingResults = false;
                this.disableButton = false;
            });
        }
    }

    roleEventEmitter(roles: Role[]) {
        this.lstSelectedRole = roles;
        this.disableButton = !this.validateSearchEnable();
    }

    paginatorEvent() {
        this.dataSource.sortingDataAccessor = sortingDataAccessor;
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.searchPaginator;
    }

    announceSortChange(sortState: Sort) {
        this.paginatorEvent();
    }
    validateSearchEnable() {
        if (
            this.lstSelectedRegion.length > 0 ||
            this.lstSelecteddistrict.length > 0 ||
            this.lstSelectedRole.length > 0 ||
            this.searchTextCtrl.value?.length > 0
        ) {
            return true;
        } else return false;
    }

    reset() {
        this.searchTextCtrl.setValue('');
        this.resetField = !this.resetField;
        //This is optional code To resetthe value after
        const s = timer(1000);
        s.subscribe((val) => {
            this.resetField = !this.resetField;
        });

        //Once ray emits reset for District need to implment.
        this.dataSource = new MatTableDataSource<User>();
        this.isLoadingResults = false;
        this.disableButton = true;
    }

    getElementData(u: User) {
        if (u.TELEPHONE_NUMBERS == null || u.TELEPHONE_NUMBERS === undefined || u.TELEPHONE_NUMBERS.length <= 0) {
            return '';
        } else {
            return (
                u?.TELEPHONE_NUMBERS[0]?.CONTACT_MECHANISMS.PARTY_CONTACT_MECHANISMS[0]?.PARTY_CONTACT_MECHANISM_PURPOSES[0]?.CONTACT_MECHANISM_PURPOSE_TYPES?.TYPE.substring(
                    0,
                    1
                ) +
                ': ' +
                u?.TELEPHONE_NUMBERS[0]?.PHONE_NUMBER
            );
        }
    }

    showFilterData(action: string) {
        switch (action) {
            case 'ResetPassword':
                if (this.passwordResetStatus) {
                    this.dataSource.data = this.lstUser.filter(
                        (x) => x.LOGIN_DETAIL_PASSWORD_RECOVERIES != null && x.LOGIN_DETAIL_PASSWORD_RECOVERIES?.length > 0
                    );
                    this.currentSession = false;
                    this.accountCreation = false;
                } else {
                    this.dataSource.data = this.lstUser;
                }
                break;
            case 'RemoveSession':
                if (this.currentSession) {
                    this.dataSource.data = this.lstUser.filter((x) => x.LOGIN_DETAIL_SESSIONS != null && x.LOGIN_DETAIL_SESSIONS?.length > 0);
                    this.passwordResetStatus = false;
                    this.accountCreation = false;
                } else {
                    this.dataSource.data = this.lstUser;
                }
                break;
            case 'CreateAccount':
                if (this.accountCreation) {
                    this.dataSource.data = this.lstUser.filter((x) => x.LOGIN_DETAILS_CREATION != null && x.LOGIN_DETAILS_CREATION?.length > 0);
                    this.passwordResetStatus = false;
                    this.currentSession = false;
                } else {
                    this.dataSource.data = this.lstUser;
                }
                break;
        }
    }
    callActionAPI(action: string, row: User) {
        let content = '';
        let msg = '';
        switch (action) {
            case 'ResetPassword':
                msg = "Are you sure you want to reset this user's password? ";
                if (row.LOGIN_DETAIL_PASSWORD_RECOVERIES != null && row.LOGIN_DETAIL_PASSWORD_RECOVERIES?.length > 0) {
                    msg += '(Reset again)';
                    content =
                        "<p> <a href='/accounts/password/recovery/" +
                        row.LOGIN_DETAIL_PASSWORD_RECOVERIES[0].EMAIL_CONFIRMATION_CODE +
                        "'" +
                        " target='_blank'> Current password change link </a> </p>";

                    console.log(content);
                }
                this.openDialog(action, msg, content, row);
                break;
            case 'RemoveSession':
                this.openDialog(action, "Are you sure you want to remove this user's sessions?", content, row);
                break;
            case 'CreateAccount':
                msg = 'Are you sure you want to allow this user to re-create their Username/Password? ';
                if (row.LOGIN_DETAILS_CREATION != null && row.LOGIN_DETAILS_CREATION?.length > 0) {
                    msg += '(Resend)';
                    content =
                        "<p> <a href='/accounts/new/user/" +
                        row.LOGIN_DETAILS_CREATION[0].EMAIL_CONFIRMATION_CODE +
                        "'" +
                        " target='_blank'> Current username/password creation link </a> </p>";
                }
                this.openDialog(action, msg, content, row);
                break;
        }
    }
    view(row: User) {
        this.accountService.getAccount({ id: row.ID }).subscribe((x) => {
            let u: UserModel = x;
            //u.REGION = row.REGION;
            //u.WORKS_FOR = row.WORKS_FOR;
            //u.TELEPHONE_NUMBERS = row.TELEPHONE_NUMBERS;

            const dialogRef = this.dialog.open(ViewAccountComponent, {
                disableClose: true,
                width: '90%',
                height: '90%',
                data: u
            });
            dialogRef.afterClosed().subscribe((result) => {});
        });
    }
    edit(row: any) {
        this.accountService.getAccount({ id: row.ID }).subscribe((x) => {
            let u: UserModel = x;
            const dialogRef = this.dialog.open(EditAccountComponent, {
                disableClose: true,
                width: '90%',
                height: '90%',
                data: u
            });
            dialogRef.afterClosed().subscribe((result: UserModel) => {
                if (result != undefined) {
                    let index = this.dataSource.data.findIndex((x) => x.ID === result.ID);
                    if (index >= 0) {
                        this.dataSource.data[index].LOGIN_DETAIL_STATUS = result.LOGIN_DETAIL_STATUS;
                        this.dataSource.data[index].PERSON!.FIRST_NAME = result.PERSON?.FIRST_NAME;
                        this.dataSource.data[index].PERSON!.LAST_NAME = result.PERSON?.LAST_NAME;
                        this.dataSource.data[index].EMAIL_ADDRESS = result.EMAIL_ADDRESS;
                        this.dataSource.data[index].WORK_TITLE = result.WORK_TITLE;
                        this.dataSource.data[index].WORKS_FOR = result?.WORKS_FOR;
                        this.dataSource.data[index].SCHOOL_DISTRICTS = result.SCHOOL_DISTRICTS;
                        this.dataSource.data[index].REGION = result?.REGION;
                        this.dataSource.data[index].USER_ROLES = result?.USER_ROLES;
                    }
                }
            });
        });
    }

    openDialog(action: string, msg: string, content: string, row: User) {
        const dialogRef = this.dialog.open(ConfirmChangesComponent, {
            width: '600px',
            height: '140px',
            data: { msg: msg, content: content }
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result['closed'] == true) {
                switch (action) {
                    case 'ResetPassword':
                        row.filter = ['Pending Reset Password'];
                        this.accountService.resetPassword({ user: row, sendEmail: true }).subscribe((x) => {
                            let msg: MsgModel;
                            if (x['msg'] !== undefined) {
                                msg = x['msg'];
                                if (msg.SUCCESS) {
                                    row.LOGIN_DETAIL_PASSWORD_RECOVERIES = [x['loginDetailPasswordRecovery']];
                                }
                            }
                        });
                        break;
                    case 'RemoveSession':
                        row.filter = ['Current Session Active'];
                        this.accountService.removeSessions({ user: row }).subscribe((x) => {
                            let msg: MsgModel;
                            if (x['msg'] !== undefined) {
                                msg = x['msg'];
                                if (row.ID === this.loginTokenService.getUser().ID) {
                                    this.loginTokenService.logout();
                                    this.router.navigateByUrl('/login');
                                }
                            }
                        });
                        break;
                    case 'CreateAccount':
                        row.filter = ['Account Creation Active'];
                        this.accountService.reCreateNewUser({ newUser: row }).subscribe((x) => {
                            let msg: MsgModel;
                            if (x['msg'] !== undefined) {
                                msg = x['msg'];
                                if (msg.SUCCESS) {
                                    row.LOGIN_DETAILS_CREATION = [x['loginDetailsCreation']];
                                }
                            }
                        });

                        break;
                }
            }
        });
    }

    openDialogRoles(ur: USERROLE[]) {
        const dialogRef = this.dialog.open(PopOverComponent, {
            width: '350px',
            height: ur?.length < 5 ? '100px' : ur?.length > 10 ? '500px' : '200px',
            data: { key: ur.map((x) => x.ROLE?.NAME), start: 4 }
        });

        dialogRef.afterClosed().subscribe((result) => {});
    }

    openDialogSchoolDistrict(sd: SchoolDistrict[]) {
        const dialogRef = this.dialog.open(PopOverComponent, {
            width: '350px',
            height: sd?.length < 5 ? '100px' : sd?.length > 5 ? '500px' : '250px',
            data: { key: sd.map((x) => x.DISTRICTS), start: 4 }
        });

        dialogRef.afterClosed().subscribe((result) => {});
    }

    getSessionCount() {
        this.accountService.getSessionCount().subscribe((x) => {
            this.isLoadingCount = true;
            this.totalSessionCount = x['sessionCount'];
        });
    }

    activeSessionData() {}
}
